import { student } from "../client";

export const attendancePercentage = (params) => {
  const user = {
    flag: "getStudentPercentage",
    authorization: "",
    parameters: {
      ...params,
    },
  };
  return student.post(
    "/admin/dashboard/get/attendancePercentage",
    user
  );
};